import React from 'react';
import { Sun, Wrench, Code2, Cpu } from 'lucide-react';

const audiences = [
  { icon: Sun, title: 'Developers', desc: 'Screen sites and design to every requirement city and utility.' },
  { icon: Wrench, title: 'EPCs & Installers', desc: 'Build and permit in any city without surprises.' },
  { icon: Code2, title: 'Software Platforms', desc: 'Keep requirements current inside your products for your users.' },
  { icon: Cpu, title: 'Hardware Manufacturers', desc: 'Provide utility and local requirements for installers for fast deployment.' },
];

const WhoUsesFordje = () => (
  <section className="pt-16 md:pt-20 pb-8 md:pb-10 bg-background">
    <div className="container-custom max-w-6xl mx-auto">
      <p className="text-[15px] uppercase tracking-widest text-primary font-medium mb-4 text-center">Who uses Fordje</p>
      <h2 className="mb-10 text-center">Built for the whole clean energy ecosystem.</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {audiences.map((a) => {
          const Icon = a.icon;
          return (
            <div key={a.title} className="rounded-xl border bg-card p-6 h-full transition-shadow hover:shadow-md">
              <div className="rounded-lg bg-primary/10 p-3 inline-flex mb-4"><Icon className="h-5 w-5 text-primary" /></div>
              <h3 className="text-lg font-semibold mb-2 text-foreground">{a.title}</h3>
              <p className="text-muted-foreground leading-relaxed">{a.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default WhoUsesFordje;
